module.exports = __webpack_public_path__ + "img/olga-guryanova-1408134-unsplash.1aa8e554.jpg";